// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"5f8e51c7","330":"d4e8925a","523":"4411807b","776":"15fd1277"}[chunkId] + ".chunk.js";
};